module.exports = __webpack_public_path__ + "static/img/xunjiangongzuo.f9e773e5.png";